import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import ProfileField from '../components/ProfileField';
import Feed from '../components/Feed';
import { 
  getStudentProfileByUsername, 
  editProfile, 
  changePassword, 
  changeUsername 
} from '../services/StudentService';
import { getPostsByUserId } from '../services/PostService';
import '../styles/ProfilePage.css';
import '../styles/ProfileField.css';
import defaultProfile from '../assets/default-profile.png';
import { FaPen } from 'react-icons/fa';
import ChangeModal from '../components/ChangeModal';

export default function ProfilePage(){
  const username = localStorage.getItem('username');
  const userId = localStorage.getItem('studentId');
  const navigate = useNavigate();

  const currentUser = userId ? { studentId: userId } : null;

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    highSchoolStatus: '',
    highSchoolGraduateYear: '',
    bio: '',
    profession: '',
    universityName: '',
    city: '',
    phoneNumber: '',
    profilePhotoUrl: ''
  });

  const [universities, setUniversities] = useState([]);
  const [professions, setProfessions] = useState([]);
  const [cities, setCities] = useState([]);

  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [loadingPosts, setLoadingPosts] = useState(false);

  const [hasChanges, setHasChanges] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [error, setError] = useState('');

  const [showCustomUniversity, setShowCustomUniversity] = useState(false);
  const [showCustomCity, setShowCustomCity] = useState(false);
  const [showCustomProfession, setShowCustomProfession] = useState(false);

 const [isUsernameModalOpen, setIsUsernameModalOpen] = useState(false);
const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);

  // Şifre değişikliği
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordMessage, setPasswordMessage] = useState('');

  // Kullanıcı adı değişikliği
  const [newUsername, setNewUsername] = useState('');
  const [usernameMessage, setUsernameMessage] = useState('');

  const sasToken = process.env.REACT_APP_AZURE_BLOB_SAS_TOKEN;

  // Profil fotoğrafı yükleme
  async function handleImageUpload(file) {
    if (!file) return;

    const blobName = `${Date.now()}-${file.name}`;
    const uploadUrl = `https://iklmezunagi.blob.core.windows.net/iklphoto/${blobName}?${sasToken}`;

    try {
      const res = await fetch(uploadUrl, {
        method: 'PUT',
        headers: { 'x-ms-blob-type': 'BlockBlob', 'Content-Type': file.type },
        body: file
      });
      if (!res.ok) throw new Error(`Upload başarısız! Status: ${res.status}`);
      return `https://iklmezunagi.blob.core.windows.net/iklphoto/${blobName}`;
    } catch (err) {
      console.error('Fotoğraf yükleme hatası:', err);
      throw err;
    }
  }

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) navigate('/');
  }, [navigate]);

  useEffect(() => {
    if (!username) return;

    getStudentProfileByUsername(username).then(res => {
      if (res.isSuccess && res.data) {
        const uniRaw = res.data.universityName || '';
        const cleanUni = uniRaw.toLowerCase().includes('belirtilmemiş') ? '' : uniRaw;
        setFormData({
          firstName: res.data.firstName || '',
          lastName: res.data.lastName || '',
          email: res.data.email || '',
          highSchoolStatus: res.data.highSchoolStatus || '',
          highSchoolGraduateYear: res.data.highSchoolFinishYear || '',
          bio: res.data.bio || '',
          profession: res.data.profession || '',
          universityName: cleanUni,
          city: res.data.city || '',
          phoneNumber: res.data.phoneNumber || '',
          profilePhotoUrl: res.data.profilePhotoUrl || ''
        });
      } else {
        setError(res.failMessage || 'Profil bilgileri alınamadı');
      }
    }).catch(err => setError(err.message));
  }, [username]);

  useEffect(() => {
    if (!userId) return;
    setLoadingPosts(true);
    getPostsByUserId(userId, page)
      .then(res => setPosts(res))
      .catch(err => console.error('Gönderiler alınamadı:', err))
      .finally(() => setLoadingPosts(false));
  }, [userId, page]);

  useEffect(() => { 
    fetch('/data/meslekler.json')
      .then(res => res.json())
      .then(data => setProfessions([...data,'Diğer']))
      .catch(console.error); 
  }, []);

  useEffect(() => { 
    fetch('/data/uni.json')
      .then(res => res.json())
      .then(data => setUniversities([...data,'Diğer']))
      .catch(console.error); 
  }, []);

  useEffect(() => { 
    fetch('https://turkiyeapi.dev/api/v1/provinces')
      .then(res => res.json())
      .then(data => { 
        if (data.status==='OK') setCities([...data.data.map(c=>c.name),'Diğer']); 
      })
      .catch(console.error); 
  }, []);

  const onFieldChange = (field, value) => {
    setFormData(prev => { 
      const newData = { ...prev, [field]: value }; 
      setHasChanges(true); 
      setSuccessMessage(''); 
      setError(''); 
      return newData; 
    });
  };

  const handleSave = async () => {
    setError(''); 
    setSuccessMessage('');

    try {
      const payload = { ...formData, highSchoolGraduateYear: Number(formData.highSchoolGraduateYear) || null };
      const res = await editProfile(payload);
      if (res.isSuccess) {
        setSuccessMessage('Profil başarıyla güncellendi.');
        setHasChanges(false);
      } else {
        setError(res.failMessage || 'Güncelleme başarısız.');
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const handlePasswordChange = async () => {
    setPasswordMessage('');
    if (!oldPassword || !newPassword || !confirmPassword) {
      setPasswordMessage('Tüm alanlar doldurulmalı');
      return;
    }
    if (newPassword !== confirmPassword) {
      setPasswordMessage('Yeni şifreler eşleşmiyor');
      return;
    }
    if (newPassword.length < 4) {
      setPasswordMessage('Şifre en az 4 karakter olmalıdır.');
      return;
    }

    try {
      const res = await changePassword(oldPassword, newPassword);
      if (res.isSuccess) {
        setPasswordMessage('Şifre başarıyla değiştirildi');
        setOldPassword(''); 
        setNewPassword(''); 
        setConfirmPassword('');
      } else {
        setPasswordMessage(res.failMessage || 'Şifre değiştirilemedi');
      }
    } catch (err) {
      setPasswordMessage(err.message);
    }
  };

 const handleUsernameChange = async () => {
  if (!newUsername) { 
    setUsernameMessage('Yeni kullanıcı adı boş olamaz'); 
    return; 
  }
  const usernameRegex = /^[a-zA-Z0-9_]+$/;
  if (!usernameRegex.test(newUsername)) {
    setUsernameMessage('Kullanıcı adı sadece harf, rakam ve "_" karakterini içerebilir.');
    return;
  }

  try {
    const res = await changeUsername(newUsername);
    setUsernameMessage(res.responseMessage || (res.isSuccess ? 'Kullanıcı adı değiştirildi' : 'Kullanıcı adı değiştirilemedi'));
    if (res.isSuccess) localStorage.setItem('username', newUsername);
  } catch (err) { 
    console.error('Username change error:', err);
    try {
      const errorData = JSON.parse(err.message);
      setUsernameMessage(errorData.failMessage || 'Kullanıcı adı değiştirilemedi');
    } catch {
      setUsernameMessage(err.message || 'Kullanıcı adı değiştirilemedi');
    }
  }
};

return (
  <>
    <Navbar />
    <div className="profile-page">
      <div className="profile-left">
        <h2>Profil Bilgilerim</h2>

        <div className="photo-upload">
          <label>Profil Fotoğrafı</label>
          <div className="photo-container" onClick={() => document.getElementById('profilePhotoInput').click()}>
            <img src={formData.profilePhotoUrl || defaultProfile} alt="Profil" className="profile-photo"/>
            <div className="edit-icon"><FaPen /></div>
          </div>
          <input 
            id="profilePhotoInput" 
            type="file" 
            accept="image/*" 
            style={{display:'none'}} 
            onChange={async e => {
              try { 
                const file = e.target.files[0]; 
                if(!file) return; 
                const uploadedUrl = await handleImageUpload(file); 
                setFormData(prev => ({...prev, profilePhotoUrl: uploadedUrl})); 
                setHasChanges(true); 
              } catch(err) {
                alert('Fotoğraf yükleme hatası: ' + err.message);
              }
            }} 
          />
        </div>

        <div className="readonly-field" onClick={() => setIsUsernameModalOpen(true)}>
          <label>Kullanıcı Adı</label>
          <input type="text" value={username || ''} readOnly />
        </div>

        <ProfileField label="İsim" value={formData.firstName} onChange={val => onFieldChange('firstName', val)} />
        <ProfileField label="Soyisim" value={formData.lastName} onChange={val => onFieldChange('lastName', val)} />
        <ProfileField label="Email" value={formData.email} onChange={val => onFieldChange('email', val)} />
        <ProfileField 
          label="Lise Durumu" 
          value={formData.highSchoolStatus} 
          onChange={val => onFieldChange('highSchoolStatus', val)} 
          type="radio" 
          options={['Mezun','Öğrenci']} 
        />

        <ProfileField
          label="Lise Mezuniyet Yılı"
          type="select"
          value={formData.highSchoolGraduateYear}
          onChange={val => onFieldChange('highSchoolGraduateYear', val)}
          options={[
            "Lise Mezuniyet Yılı",
            ...Array.from({ length: new Date().getFullYear() - 1970 + 1 }, (_, i) => (new Date().getFullYear() - i).toString())
          ]}
        />
        <ProfileField 
          label="Hakkımda" 
          value={formData.bio} 
          type="textarea" 
          placeholder={"Örnek:\n- Yazılım geliştirici\n- Kitap okumayı severim\n- Seyahat etmeyi severim"} 
          onChange={val => onFieldChange('bio', val)}
        />
        <ProfileField 
          label="Meslek" 
          value={formData.profession} 
          type="select" 
          options={professions} 
          onChange={val => { 
            setShowCustomProfession(val === 'Diğer'); 
            if(val !== 'Diğer') onFieldChange('profession', val); 
            else onFieldChange('profession', '');
          }} 
        />
        {showCustomProfession && <input type="text" placeholder="Meslek adını giriniz" value={formData.profession} onChange={e => onFieldChange('profession', e.target.value)} />}

        <ProfileField 
          label="Üniversite" 
          value={formData.universityName} 
          type="select" 
          options={universities} 
          onChange={val => { 
            setShowCustomUniversity(val === 'Diğer'); 
            if(val !== 'Diğer') onFieldChange('universityName', val); 
            else onFieldChange('universityName', '');
          }} 
        />
        {showCustomUniversity && <input type="text" placeholder="Üniversite adını giriniz" value={formData.universityName} onChange={e => onFieldChange('universityName', e.target.value)} />}

        <ProfileField 
          label="Şehir" 
          value={formData.city} 
          type="select" 
          options={cities} 
          onChange={val => { 
            setShowCustomCity(val === 'Diğer'); 
            if(val !== 'Diğer') onFieldChange('city', val); 
            else onFieldChange('city', '');
          }} 
        />
        {showCustomCity && <input type="text" placeholder="Şehir adını giriniz" value={formData.city} onChange={e => onFieldChange('city', e.target.value)} />}

        <ProfileField 
          label="Telefon Numarası" 
          value={formData.phoneNumber} 
          type="tel" 
          placeholder="Örn: 5xx xxx xxxx (Opsiyonel)" 
          onChange={val => onFieldChange('phoneNumber', val)}
        />

        
 
    <div className="modal-section">
        {/* Kullanıcı Adı Değiştir */}
        <button className="small-red-btn" onClick={() => setIsUsernameModalOpen(true)}>
          Kullanıcı Adı Değiştir
        </button>
        <ChangeModal
          title="Kullanıcı Adı Değiştir"
          isOpen={isUsernameModalOpen}
          onClose={() => setIsUsernameModalOpen(false)}
        >
          <input 
            type="text" 
            placeholder="Yeni kullanıcı adı" 
            value={newUsername} 
            onChange={e => setNewUsername(e.target.value)} 
          />
          <div className="modal-buttons">
            <button className="small-red-btn" onClick={handleUsernameChange}>Değiştir</button>
          </div>
          {usernameMessage && <p className="error-message">{usernameMessage}</p>}
        </ChangeModal>

        {/* Şifre Değiştir */}
        <button className="small-red-btn" onClick={() => setIsPasswordModalOpen(true)}>
          Şifreyi Değiştir
        </button>
       <ChangeModal
          title="Şifre Değiştir"
          isOpen={isPasswordModalOpen}
          onClose={() => setIsPasswordModalOpen(false)}
          modalClass="password-modal"  // yeni prop
        >
          <input 
            type="password" 
            placeholder="Eski Şifre" 
            value={oldPassword} 
            onChange={e => setOldPassword(e.target.value)} 
          />
          <input 
            type="password" 
            placeholder="Yeni Şifre" 
            value={newPassword} 
            onChange={e => setNewPassword(e.target.value)} 
          />
          <input 
            type="password" 
            placeholder="Yeni Şifre (Tekrar)" 
            value={confirmPassword} 
            onChange={e => setConfirmPassword(e.target.value)} 
          />
          <div className="modal-buttons">
            <button className="change-btn" onClick={handlePasswordChange}>Şifreyi Değiştir</button>
          </div>
          {passwordMessage && <p className="error-message">{passwordMessage}</p>}
        </ChangeModal>

      </div>


        
        <button className="save-btn" disabled={!hasChanges} onClick={handleSave} title={!hasChanges ? 'Değişiklik yapınca aktifleşir' : 'Kaydet'}>
          Kaydet
        </button>
        {successMessage && <p className="success-message">{successMessage}</p>}
        {error && <p className="error-message">{error}</p>}


      </div>

      <div className="profile-right">
        <h2>Gönderilerim</h2>
        {loadingPosts ? <p>Gönderiler yükleniyor...</p> :
          <Feed posts={posts} currentUser={currentUser} page={page} setPage={setPage} onUpdate={() => setPage(1)} />}
      </div>
    </div>
  </>
);

}
